<template>
  <div class="form-layout">
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview :title="title">
          <template v-slot:preview>
            <slot name="form"></slot>
          </template>
          <template v-slot:foot>
            <slot name="actions"></slot>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';

export default {
  name: 'FormLayout',
  components: {
    KTCodePreview,
  },
  props: {
    title: {
      type: String,
      default: 'Thông tin tài khoản kế toán',
    },
  },
};
</script>

<style scoped>
.form-layout {
  width: 100%;
}
</style> 
